module.exports = __webpack_public_path__ + "img/ch76.88859391.jpg";